import { FunctionCloneDeep } from "radium-omnibus";

export const PricingClickToCart = async ({
  size,
  master,
  master_id,
  cart,
  setCart,
  navigate,
  self,
  Storage,
  type,
}) => {
  // console.log("ASD", { size, master, master_id, cart, setCart, self });
  await setCart((prev) => {
    let temp = FunctionCloneDeep([...prev]);

    const findMaster = temp?.findIndex((item) => {
      return item.master_id === self.master_id;
    });

    // console.log("findMaster", findMaster);

    if (findMaster >= 0) {
      temp[findMaster] = self;
      Storage([...temp]);
      return [...temp];
    } else {
      sessionStorage.setItem("pricingSize", size);
      Storage(prev);
      return prev;
    }
  });

  if (type === "My Wash") {
    navigate("/MyWash");
  } else if (type === "My Iron") {
    navigate("/MyIron");
  } else if (type === "My Shoes") {
    navigate("/MyShoes");
  }
};

const ProgramClickToCart = (
  setCart,
  addOn = [],
  Storage,
  master,
  navigate,
  water = [],
  extras = [],
  type
) => {
  try {
    if (master) {
      //ADD FROM IS_SELECTED
      const all = [...addOn, ...water, ...extras];
      const selected = all.filter((d) => d.isSelected);

      // console.log("selected", {
      //   setCart,
      //   addOn,
      //   Storage,
      //   master,
      //   navigate,
      //   water,
      //   extras,
      //   type,
      //   selected,
      // });

      // const alreadyHave =
      all?.forEach((i) => {
        if (i.isSelected) {
          setCart((prev) => {
            let temp = FunctionCloneDeep([...prev]);
            const findItem = temp?.findIndex((item) => item._id === i._id);
            const hasMaster = temp?.findIndex((item) => {
              return item?.master_type === type && item?.type === "PACKAGE";
            });

            if (hasMaster === -1) {
              temp.push(master);
            }

            if (hasMaster >= 0) {
              temp[hasMaster] = master;
            }

            if (findItem === -1) {
              // const findMaster = temp?.findIndex((item) => {
              //   return item._id === master._id;
              // });
              // if (findMaster === -1) {
              //   temp.push(master);
              // }

              temp.push(i);
            }
            Storage([...temp]);
            return [...temp];
          });
        } else {
          setCart((prev) => {
            let temp = [...prev];
            const findItem = temp?.findIndex((item) => item._id === i._id);
            if (findItem >= 0) {
              temp.splice(findItem, 1);
            }
            Storage([...temp]);
            return [...temp];
          });
        }
      });

      if (selected.length === 0) {
        setCart((prev) => {
          let temp = FunctionCloneDeep([...prev]);

          const findMaster = temp?.findIndex((item) => {
            return item.master_id === master.master_id;
          });

          if (findMaster === -1) {
            temp.push(master);
            Storage([...temp]);
            return [...temp];
          }
          if (findMaster >= 0) {
            temp[findMaster] = master;
            Storage([...temp]);
            return [...temp];
          }
        });
      }

      navigate("/Basket");
    } else {
      alert("Please select program");
      return;
    }
  } catch (error) {
    console.error("ProgramClickToCart  :", error);
  }
};

export default ProgramClickToCart;
